(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pages-links"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const rows = document.querySelectorAll('.page-row.animate');

  rows.forEach((row, index) => {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          // cascade delay
          row.style.transitionDelay = (index * 0.1) + "s";
          row.classList.add('in-view');

          // image & text parallaxe léger
          const img = row.querySelector('.animate-image');
          const txt = row.querySelector('.animate-text');
          if(img) {
            img.style.transitionDelay = (index * 0.15) + "s";
            img.classList.add('in-view');
          }
          if(txt) {
            txt.style.transitionDelay = (index * 0.2) + "s";
            txt.classList.add('in-view');
          }

          obs.unobserve(row);
        }
      });
    }, { threshold: 0.2 });

    observer.observe(row);
  });
});

  } catch(e) { console.error(e); }
})();
})();
